import { Button } from '@eventbrite/marmalade';
import styles from './ViewDetailsButton.module.scss';
import { FormattedMessage } from 'react-intl';

export const ViewDetailsButton = ({ url }: { url: string }) => {
  const handleClick = () => {
    window.location.href = url;
  };

  return (
    <div className={styles.container}>
      <Button sizeVariant="large" className={styles.button} onClick={handleClick}>
        <FormattedMessage id="View all event details" />
      </Button>
    </div>
  );
};
